import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=22af7014&scoped=true&"
import script from "./Shadow.vue?vue&type=script&lang=js&"
export * from "./Shadow.vue?vue&type=script&lang=js&"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=22af7014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af7014",
  null
  
)

component.options.__file = "Shadow.vue"
export default component.exports